/* eslint-disable import/no-anonymous-default-export */
import {
    Checkbox,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import {
    RecordContextProvider,
    SimpleListLoading,
    useListContext,
} from 'react-admin';
import { Link } from 'react-router-dom';
import { Role } from '@/types';

export const RoleListContent = () => {
    const {
        data: roles,
        error,
        isPending,
        onToggleItem,
        selectedIds,
    } = useListContext<Role>();
    if (isPending) {
        return <SimpleListLoading hasLeftAvatarOrIcon hasSecondaryText />;
    }
    if (error) {
        return null;
    }

    return (
        <>
            <List dense>
                {roles.map(item => (
                    <RecordContextProvider key={item.id} value={item}>
                        <ListItem disablePadding>
                            <ListItemButton
                                component={Link}
                                to={`/roles/${item.id}/show`}
                            >
                                <ListItemIcon sx={{ minWidth: '2.5em' }}>
                                    <Checkbox
                                        edge="start"
                                        checked={selectedIds.includes(
                                            item.id
                                        )}
                                        tabIndex={-1}
                                        disableRipple
                                        onClick={e => {
                                            e.stopPropagation();
                                            onToggleItem(item.id);
                                        }}
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    primary={`${item.name}`}
                                />
                            </ListItemButton>
                        </ListItem>
                    </RecordContextProvider>
                ))}

                {roles.length === 0 && (
                    <ListItem>
                        <ListItemText primary="No roles found" />
                    </ListItem>
                )}
            </List>
        </>
    );
};
